module.exports = __webpack_public_path__ + "static/media/Pewters Avenue 3.e3e1b809.jpg";